import type { AnimationEasing, AnimationEasingName, AnimationPresetEasing, AnimationWiggleEasing } from "@/document/model/animation";
import { easeBack, easeBounce, easeCirc, easeElastic, easeIn, easeInOut, easeOut, linear, overShoot } from "@/lib/anima/easing";
import type { EaseFn } from "@/lib/anima/types";

const TAU = Math.PI * 2;

const PRESET_EASINGS: Record<AnimationEasingName, EaseFn> = {
  linear,
  easeIn,
  easeOut,
  easeInOut,
  easeCirc,
  easeBack,
  easeBounce,
  easeElastic,
  overShoot,
};

export function animationEasingFunction(easing: AnimationEasing): EaseFn {
  if (easing.kind === "wiggle") {
    return wiggleEasingFunction(easing);
  }
  return presetEasingFunction(easing);
}

function presetEasingFunction(easing: AnimationPresetEasing): EaseFn {
  return PRESET_EASINGS[easing.name] ?? linear;
}

function wiggleEasingFunction(easing: AnimationWiggleEasing): EaseFn {
  return (x: number) => (
    Math.sin(x * easing.frequency * TAU + easing.phase) *
    easing.amplitude *
    Math.exp(-easing.decay * x)
  );
}
